<template>
  <div
    class="container container--tight"
    :class="{ 'container--small': size === 'small' }"
  >
    <h3 class="mrgt0">
      {{ title }}
    </h3>

    <slot />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: 'small',
    },
  },
};
</script>
